import React from 'react';
import ReactDOM from 'react-dom/client';
import './global.css';

// Router App
import App from './App'

// Store
import { Provider } from 'react-redux'
import { store, persistor } from './store'

// Persist Redux
import { PersistGate } from 'redux-persist/lib/integration/react'

// Load FontAwesome Library
import './assets/fonts/fontAwesomeLibrary'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>
);
